import {type RumGlobal} from '@datadog/browser-rum';

import {type RunsLinePlotConfig} from '../../types';

export function checkBackendLinesSupport({
  config,
  context: {
    datadogRum,
    isInReport,
    panelId,
    usesBackendLineConstruction,
    usesBackendLineConstructionInReports,
  },
  usesBackendLineConstructionSmoothing,
  usesBackendLineConstructionTimeUnits,
}: {
  config: RunsLinePlotConfig;
  context: {
    datadogRum: RumGlobal;
    isInReport?: boolean;
    panelId?: string;
    usesBackendLineConstruction: boolean;
    usesBackendLineConstructionInReports: boolean;
  };
  usesBackendLineConstructionSmoothing: boolean;
  usesBackendLineConstructionTimeUnits: boolean;
}) {
  const sharedContext = {
    panelId,
    usesBackendLineConstruction,
    usesBackendLineConstructionSmoothing,
  };

  if (isInReport && !usesBackendLineConstructionInReports) {
    datadogRum.addAction('backend lines not supported', {
      reason: 'report panel',
      ...sharedContext,
    });
    return false;
  }

  if (config.metrics && config.xAxis && config.metrics.includes(config.xAxis)) {
    datadogRum.addAction('backend lines not supported', {
      reason: 'shared x and y axis metric',
      ...sharedContext,
    });
    return false;
  }

  if (config.expressions) {
    datadogRum.addAction('backend lines not supported', {
      reason: 'y-axis expressions',
      ...sharedContext,
    });
    return false;
  }

  if (config.xExpression) {
    datadogRum.addAction('backend lines not supported', {
      reason: 'x-axis expressions',
      ...sharedContext,
    });
    return false;
  }

  if (
    config.smoothingWeight &&
    config.smoothingWeight > 0 &&
    !usesBackendLineConstructionSmoothing
  ) {
    datadogRum.addAction('backend lines not supported', {
      reason: 'smoothing statsig flag disabled',
      ...sharedContext,
    });
    return false;
  }

  if (
    (config.xAxis === '_absolute_runtime' || config.xAxis === '_runtime') &&
    !usesBackendLineConstructionTimeUnits
  ) {
    datadogRum.addAction('backend lines not supported', {
      reason: 'backend line construction time units disabled',
      ...sharedContext,
    });
    return false;
  }

  // log scales not yet supported
  if (config.xLogScale || config.yLogScale) {
    datadogRum.addAction('backend lines not supported', {
      reason: 'log scales',
      ...sharedContext,
    });
    return false;
  }

  // cannot do backend lines for non-bucketing, should never be hit
  if (config.pointVisualizationMethod !== 'bucketing-gorilla') {
    datadogRum.addAction('backend lines not supported', {
      reason: 'non-bucketing visualization method',
      ...sharedContext,
    });
    return false;
  }

  return true;
}
